<template>
    <div class="dashboard">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-2 col-1 p-0">
                    <SideBar 
                        @setCurrentTab="currentTab = $event" 
                        v-if="campaigns && !loader" 
                        :empty-campaigns="campaigns && !campaigns.length && !loader"
                    />
                </div>
                <div class="col-lg-10 col-11 dashboard-content">
                    <div class="router-view-container">
                        <OverviewCard/>
                        <router-view  :currentTab="currentTab" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from './SideBar'
import {useCampaigns, useUserId } from '../../core/hooks'
import {Loader} from '../../components/Icons'
import OverviewCard from './OverviewCard'

export default {
    name: 'Dashbaord',
    components: {
        SideBar,
        Loader,
        OverviewCard
    },
    setup(){
        const {userId} = useUserId()
        const {campaigns, loader} = useCampaigns(userId)
        
        const currentTab = 'publish'

        return {
            campaigns,
            loader,
            currentTab,
        }
    }
}
</script>

<style lang="scss">
@import '../../assets/scss/variables.scss';
div.dashboard {
    p {
        margin-bottom: 0;
    }

    div[data-name="card-title"] {
        display: flex;
        align-items: center;
        p {
            font-size: $p2;
            font-weight: $weight_bold;
            color: $c6;
            margin-right: 8px;
        }
    }

    .dashboard-content {
        margin-top: 60px;
    }
}
@media (max-width: 1300px) and (min-width: 992px) {
    div.router-view-container {
        padding-left: 48px;
    }
}
</style>